<template>
<div class="chapter">
<div class="inner_page">
<p class="noindents">A Note for the Reader: This book is substantially autobiographical. All diary-style entries are Stephen Kershaw’s own words, from letters written on the aircraft carriers at sea in the 1970s. All other narrative material is from a reconstructed point of view, based on personal recollections and primary evidence.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Fm01.vue?8b25faa6